import setupRoutes from '@/navigation/vertical/admin/setup'
import designRoutes from '@/navigation/vertical/admin/design'
import marketingRoutes from '@/navigation/vertical/admin/marketing'
import managementRoutes from '@/navigation/vertical/admin/management'
// import logsRoutes from '@/navigation/vertical/admin/logs'

// import USER_TYPES from '@/constants/authorization/user-types'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

const branchAdminRoutes = [...setupRoutes, ...designRoutes]

const items = [
  {
    title: 'navigation.dashboard',
    route: 'admin:dashboard',
    svgIcon: 'icon-dashboard',
    permission: SUBUSER_PERMISSION_SLUGS.GENERAL_STATISTICS_VIEW,
  },
  {
    title: 'navigation.all-tools',
    route: 'admin:shortcuts',
    svgIcon: 'icon-all-tools',
  },
  ...branchAdminRoutes,
  // ...branchAdminRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN] })),
  ...marketingRoutes,
  // ...marketingRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_SUPERVISOR] })),
  ...managementRoutes,
  // ...managementRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.BRANCH_ADMIN, USER_TYPES.KITCHEN_USER] })),
  {
    title: 'navigation.payment-links',
    route: 'admin:payment-links',
    svgIcon: 'icon-payment-links',
    permission: [
      SUBUSER_PERMISSION_SLUGS.PAYMENT_LINKS_VIEW,
      SUBUSER_PERMISSION_SLUGS.PAYMENT_LINKS_MANAGE,
    ],
  },
  {
    title: 'navigation.branches-management',
    route: 'admin:branches-management',
    svgIcon: 'icon-branches',
    permission: [
      SUBUSER_PERMISSION_SLUGS.BRANCHES_MANAGE,
      SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
      SUBUSER_PERMISSION_SLUGS.BRANCHES_RECEIPT_MANAGE,
    ],
  },
  // ...logsRoutes.map(route => ({ ...route, userTypes: route?.userTypes ?? [USER_TYPES.OWNER, USER_TYPES.BRANCH_ADMIN] })),
  {
    title: 'navigation.settings',
    route: 'admin:settings',
    svgIcon: 'icon-settings',
    permission: [
      SUBUSER_PERMISSION_SLUGS.SETTINGS_BUSINESS_INFO_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_BUSINESS_SETTINGS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_SOCIAL_LINKS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_WHATSAPP_REPORTS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_EMAIL_REPORTS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_POLICIES_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_TIERS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_TAGS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_AGE_GROUPS_VIEW,
      SUBUSER_PERMISSION_SLUGS.SETTINGS_ACCESS,
      SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
    ],
  },
]

export default items
